Object.defineProperty(exports,"__esModule",{value:true});exports.

createTimestamp=createTimestamp;exports.





getDate=getDate;var _timestamp_pb=require('google-protobuf/google/protobuf/timestamp_pb');function createTimestamp(date){var timestamp=new _timestamp_pb.Timestamp();timestamp.fromDate(date);return timestamp;}function getDate(timestamp){
return timestamp.toDate();
}